import { getTextColorAutoContrast } from 'libs/calculateColorContrastRatio'
import * as R from 'ramda'
import React from 'react'
import { SURVEY_FONTS } from 'organisms/BrandSettings'

export const SYSTEM_FONT_CSS_VALUE =
  'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'

/**
 * @param {string} accentColor
 * @param {string} backgroundColor
 * @param {string=} backgroundImage
 * @param {string=} customCSS
 * @param {string} font
 * @param {string=} surveyLogoUrl
 *
 * @returns string
 */
export function getPreviewStyle(
  accentColor,
  backgroundColor,
  backgroundImage,
  customCSS,
  font,
  surveyLogoUrl
) {
  const infoColor = getTextColorAutoContrast(backgroundColor.toLowerCase())
  const fontFamily = font === 'System Font' ? SYSTEM_FONT_CSS_VALUE : font
  let customStyle = `:root {
      --survey-background: ${backgroundColor};
      --accent: ${accentColor};
      --accent-darker: ${calculateAccentDarkerColor(accentColor)};
      --survey-background-image: url(${backgroundImage});
      --font-family: ${fontFamily};
      --info-color: ${infoColor};
    }`

  let customLogo = ` .logo {display: none;} .thank-you-header .thank-you-logo {display: none;}`
  if (surveyLogoUrl) {
    customLogo = ` .logo {content: url(${surveyLogoUrl});}`
    const customLogoThankyouPage = ` .thank-you-logo {content: url(${surveyLogoUrl});}`
    customLogo += customLogoThankyouPage
  }
  customStyle += customLogo

  if (customCSS) {
    customStyle += customCSS
  }

  return customStyle
}

/**
 *
 * https://stackoverflow.com/a/13532993
 *
 * @param {string} hexColor
 * @returns {string}
 */
function calculateAccentDarkerColor(hexColor) {
  const PERCENT_DARKEN = -15
  const BASE = 16
  var R = parseInt(hexColor.substring(1, 3), BASE)
  var G = parseInt(hexColor.substring(3, 5), BASE)
  var B = parseInt(hexColor.substring(5, 7), BASE)

  R = Math.floor((R * (100 + PERCENT_DARKEN)) / 100)
  G = Math.floor((G * (100 + PERCENT_DARKEN)) / 100)
  B = Math.floor((B * (100 + PERCENT_DARKEN)) / 100)

  R = R < 255 ? R : 255
  G = G < 255 ? G : 255
  B = B < 255 ? B : 255

  var RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16)
  var GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16)
  var BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16)

  return '#' + RR + GG + BB
}

/**
 * @param {string} accentColor
 * @param {string=} customCSS
 * @param {string} font
 * @param {string=} surveyLogoUrl
 * @param {object=} webEmbedStyles
 *
 * @returns string
 */
export function getWebEmbedPreviewStyle(
  accentColor,
  font,
  surveyLogoUrl,
  customCSS,
  webEmbedStyles
) {
  const backgroundColor = R.prop('--survey-background', webEmbedStyles) || '#ffffff'
  const infoColor = getTextColorAutoContrast(backgroundColor.toLowerCase())
  const cssProperties = Object.entries(webEmbedStyles).map(
    ([cssProperty, value]) => `${cssProperty}: ${value}`
  )
  const webEmbedCss = R.isEmpty(cssProperties) ? '' : cssProperties.join(';')
  const fontFamily = font === 'System Font' ? SYSTEM_FONT_CSS_VALUE : font
  let customStyle = `:root {
      --survey-background: ${backgroundColor};
      --accent: ${accentColor};
      --accent-darker: ${calculateAccentDarkerColor(accentColor)};
      --font-family: ${fontFamily};
      --info-color: ${infoColor};
      ${webEmbedCss}
    }`

  let customLogo = ` .logo {display: none;} .thank-you-header .thank-you-logo {display: none;}`
  if (surveyLogoUrl) {
    customLogo = ` .logo {content: url(${surveyLogoUrl});}`
    const customLogoThankyouPage = ` .thank-you-logo {content: url(${surveyLogoUrl});}`
    customLogo += customLogoThankyouPage
  }
  customStyle += customLogo

  if (customCSS) {
    customStyle += customCSS
  }

  return customStyle
}

export function getFontOption() {
  const systemFont = {
    key: 'System Font',
    value: 'System Font',
    text: <span style={{ fontFamily: SYSTEM_FONT_CSS_VALUE }}>System Font</span>,
  }
  const googleFonts = SURVEY_FONTS.map((font) => ({
    key: font,
    value: font,
    text: <span style={{ fontFamily: font }}>{font}</span>,
  }))
  return [systemFont, ...googleFonts]
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/BrandSettings/utils.js